import { GetterTree } from 'vuex'
import { IAdminInfo } from './modules/admin/types'

const getters: GetterTree<any, any> = {
  isSuperAdmin (state, getters) {
    const user = getters['User/userInfo']
    const superAdminList = getters['Admin/superAdminList']
    return superAdminList.some((admin: IAdminInfo) => admin.userid === user.userid)
  },

  isAppAdmin (state, getters) {
    const app = getters['App/appInfo']
    const userInfo = getters['User/userInfo']
    const isAppCreator = app.creator && app.creator.userid === userInfo.userid
    const isAppDeveloper = app.admins && app.admins.some((i: any) => i.userid === userInfo.userid)
    return getters['isSuperAdmin'] || (isAppCreator && isAppDeveloper)
  },

  isAppCreator (state, getters) {
    const app = getters['App/appInfo']
    const userInfo = getters['User/userInfo']
    return app.creator && app.creator.userid === userInfo.userid
  },

  isPrivate () {
    return !!process.env.VUE_APP_IS_PRIVATE
  },

  priConfig (state) {
    return state.Plussvr && state.Plussvr.priConfig
  },

  isPriDocMiddle () {
    return window.$$DEPLOY_YUNDOC === 'false'
  },

  // 是否普通私有化版本
  isGeneralPrivate (_, getters) {
    return getters['isPrivate'] && window.$$DEPLOY_OPENDOC === 'none'
  },

  // 是否文档中台-预览编辑版本
  isPriDocEdit (_, getters) {
    return getters['isPriDocMiddle'] && window.$$DEPLOY_OPENDOC === 'edit'
  },

  CryptoConfig (_, getters) {
    return getters['priConfig'] && getters['priConfig'].encryption
  },

  needCrypto (_, getters) {
    return getters['CryptoConfig'] && getters['CryptoConfig'].isEncryption
  },

  RSA_HEAD_KEY () {
    return 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUF0YzhRRGFjNmM4c0FTQW1qYjBFMwovSU5rbnRXUHcvbGZRSjVZYUlKdHA5QyttQlhaRTFKQjcrSzdMSmJWU2hyQ3h1NnBuU2l4TjYvelo5'
  }
}

export default getters
